var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "newsletterLink" }, [
    _c("img", {
      staticClass: "img-thumbnail",
      attrs: {
        src: _vm.newsletter.imagePath,
        alt: _vm.newsletter.title + " newsletter thumbnail",
      },
    }),
    _vm._v(" "),
    _c("h3", { staticClass: "mt-3" }, [_vm._v(_vm._s(_vm.newsletter.title))]),
    _vm._v(" "),
    _c(
      "a",
      {
        attrs: {
          href: _vm.newsletter.pdfPath,
          download: "",
          target: "_blank",
          "aria-label": "Download " + _vm.newsletter.title,
        },
      },
      [_vm._v(" Download")]
    ),
    _vm._v(" "),
    _c(
      "a",
      {
        attrs: {
          href: _vm.newsletter.pdfPath,
          target: "_blank",
          "aria-label": "Open " + _vm.newsletter.title + " in new tab",
        },
      },
      [_vm._v(" Open")]
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "btn btn-link ml-2 p-0",
        attrs: { "aria-label": "View " + _vm.newsletter.title },
        on: {
          click: function ($event) {
            return _vm.$emit("item-selected", _vm.newsletter)
          },
        },
      },
      [_vm._v("View")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }